import * as React from "react";
const SvgDeviceWorkstation = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 3.754V18.375h9.381v2.246H7.314v1.506h9.372v-1.506H12.748v-2.246h9.381V3.754H12ZM3.38 5.252H20.62v11.625H3.38v-5.813zm5.99 2.062v7.498h1.508V7.314h-.754zm7.508 0v7.498h1.498V7.314h-.75zM5.625 9.187v3.754h1.498V9.187h-.748Zm7.498 0v3.754h1.508V9.187h-.754z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDeviceWorkstation;
